module.exports = __webpack_public_path__ + "img/00044.7eb773e6.webp";